/**
 * Ruta que exige sesion en el SSO.
 */

import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@presentation/context/AuthContext';
import { routes } from './routes';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <div className="loading-container">
        <p>Verificando sesion...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />;
  }

  return <>{children}</>;
}
